import type { Card } from "../../content/types";
import { isMastered } from "../../engine/mastery";
import type { Profile } from "../../state/profile";
import { CATEGORY_LABEL, daysUntilDue, heatColor } from "./utils";

type CardRowProps = {
  card: Card;
  profile: Profile;
  today: string;
  onOpen: (card: Card) => void;
  onPhonemeClick?: (phoneme: string) => void;
};

export function CardRow({ card, profile, today, onOpen, onPhonemeClick }: CardRowProps) {
  const srsCard = profile.cards[card.id];
  const mastered = isMastered(srsCard);
  const until = daysUntilDue(srsCard, today);
  const wpm = profile.bests.wpmByCard[card.id];

  return (
    <button
      type="button"
      class={"card-row" + (mastered ? " card-row-mastered" : "")}
      style={{ "--row-heat": heatColor(card.id, profile, today) }}
      onClick={() => onOpen(card)}
    >
      <span class="card-row-edge" />
      <span class="card-row-main">
        <span class="card-row-phonemes">
          {card.kind === "twister" ? (
            card.phonemes.slice(0, 4).map((p) => (
              <span
                class="card-row-chip mono card-row-chip-phoneme"
                key={p}
                onClick={(e) => {
                  e.stopPropagation();
                  onPhonemeClick?.(p);
                }}
              >
                {p}
              </span>
            ))
          ) : (
            <span class="card-row-chip mono">{card.category ? CATEGORY_LABEL[card.category] : ""}</span>
          )}
        </span>
        <span class="display card-row-text">{card.text}</span>
      </span>
      <span class="mono card-row-meta">
        <span>{wpm ? `${wpm} wpm` : "—"}</span>
        <span>{until === null ? "new" : until <= 0 ? "due" : `${until}d`}</span>
      </span>
    </button>
  );
}
